import React from 'react';
import PropTypes from 'prop-types';
import { AppProvider, Page, Form, FormLayout, Select, Button, Frame, Card } from '@shopify/polaris';
import { BasicTextField } from '@presentational';

import { PolarisFormProvider } from '@container';
import FormPageActions from '@container/FormPageActions';
import { tAttribute } from '@utils';
import merge from 'lodash/merge';

const propTypes = {
  courier: PropTypes.object.isRequired,
  update: PropTypes.bool,
  submitURL: PropTypes.string.isRequired,
};

class CourierFormWrapper extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      defaultValues: props.update ? props.courier : merge(props.courier, {name: ""}),
      method: props.update ? "PATCH" : "POST",
    }
  }

  render() {
    const { defaultValues, method } = this.state;
    let { submitURL } = this.props;
    return(
      <PolarisFormProvider
        title={ I18n.t("activerecord.models.courier.one") }
        defaultValues={ defaultValues }
        submitURL={ submitURL }
        submitMethod={ method }
        pageProps={{
          breadcrumbs: [{content: I18n.t("actions.back"), url: '/admin/couriers'}]
        }}
      >
        { ({ handleSubmit, handleChange, values, errors }) =>
          <Form onSubmit={ handleSubmit }>
            <Card>
              <Card.Section>
                <FormLayout>
                  <BasicTextField 
                    name="name"
                    label={ tAttribute("courier", "name") }
                    handleChange={handleChange} 
                    values={values} 
                    errors={errors}
                  />
                  
                  <BasicTextField 
                    name="migration_handle"
                    label={ tAttribute("courier", "migration_handle") }
                    handleChange={handleChange} 
                    values={values} 
                    errors={errors}
                  />
                </FormLayout>
              </Card.Section>
            </Card>
            <FormPageActions
              onPrimaryAction={ handleSubmit }
              deleteURL={ this.props.deleteURL }
              />
          </Form>
        }
      </PolarisFormProvider>
    )
  }
}

CourierFormWrapper.propTypes = propTypes;

export default CourierFormWrapper;
